<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '工控机信息'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="5vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="100px" :rules="rules">
      <el-tabs v-model="dsTabVisible" type="border-card">
        <el-tab-pane label="基本信息" name="0">
          <el-form-item label="站点名称" prop="Name">
            <el-input v-model.trim="item.Name" placeholder="请输入数采仪名称"></el-input>
          </el-form-item>
          <el-form-item label="站点类型" prop="Sn">
            <el-input v-model.trim="item.Sn" placeholder="请输入机器号"></el-input>
          </el-form-item>
          <el-form-item label="业务类型" prop="Mn">
            <el-input v-model.trim="item.Mn" placeholder="请输入MN号"></el-input>
          </el-form-item>
          <el-form-item label="区域" prop="Status">
            <el-select v-model="item.Status" placeholder="请选择数采仪状态" style="width: 100%">
              <el-option
                v-for="(status, index) in $sys.DS_STATUS"
                :key="index"
                :label="status"
                :value="+index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站点状态" prop="ProductionDay">
            <el-date-picker
              v-model="item.ProductionDay"
              style="width:100%"
              type="date"
              placeholder="选择出厂日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="入网日期" prop="ProductionDay">
            <el-date-picker
              v-model="item.ProductionDay"
              style="width:100%"
              type="date"
              placeholder="选择出厂日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="网络情况" prop="PurchaseUnit">
            <el-input v-model.trim="item.PurchaseUnit" placeholder="请输入购货单位"></el-input>
          </el-form-item>
          <el-form-item label="SIM卡序列" prop="Recipient">
            <el-input v-model.trim="item.Recipient" placeholder="请输入领用人"></el-input>
          </el-form-item>
          <el-form-item label="MN号" prop="SoftwareVersionID">
            <!-- <el-input v-model.trim="item.SoftwareVersion" placeholder="请输入软件版本"></el-input> -->
            <el-select v-model="item.SoftwareVersionID" placeholder="请选择软件版本" style="width: 100%">
              <el-option
                v-for="(s, index) in softwareList"
                :key="index"
                :label="s.Version"
                :value="s.ID"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" prop="HardwareVersion">
            <el-input v-model.trim="item.HardwareVersion" placeholder="请输入硬件版本"></el-input>
          </el-form-item>
          <el-form-item label="质保年限" prop="HardwareVersion">
            <el-input v-model.trim="item.HardwareVersion" placeholder="请输入硬件版本"></el-input>
          </el-form-item>
          <el-form-item label="质保开始日期" prop="ProductionDay">
            <el-date-picker
              v-model="item.ProductionDay"
              style="width:100%"
              type="date"
              placeholder="选择出厂日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="质保结束日期" prop="ProductionDay">
            <el-date-picker
              v-model="item.ProductionDay"
              style="width:100%"
              type="date"
              placeholder="选择出厂日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="Comment">
            <el-input
              v-model.trim="item.Comment"
              type="textarea"
              :autosize="{ minRows: 2 }"
              placeholder="备注"
            ></el-input>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="运维信息" name="1">
          <el-form-item label="运维单位" prop="Name">
            <el-input v-model.trim="item.Name" placeholder="请输入数采仪名称"></el-input>
          </el-form-item>
          <el-form-item label="运维人员" prop="Sn">
            <el-input v-model.trim="item.Sn" placeholder="请输入机器号"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="Mn">
            <el-input v-model.trim="item.Mn" placeholder="请输入MN号"></el-input>
          </el-form-item>
          <el-form-item label="TV ID" prop="Mn">
            <el-input v-model.trim="item.Mn" placeholder="请输入MN号"></el-input>
          </el-form-item>
          <el-form-item label="TV 密码" prop="Mn">
            <el-input v-model.trim="item.Mn" placeholder="请输入MN号"></el-input>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="硬件信息" name="2">
          <el-form-item label="工控机品牌" prop="Name">
            <el-input v-model.trim="item.Name" placeholder="请输入数采仪名称"></el-input>
          </el-form-item>
          <el-form-item label="工控机型号" prop="Sn">
            <el-input v-model.trim="item.Sn" placeholder="请输入机器号"></el-input>
          </el-form-item>
          <el-form-item label="CPU" prop="Mn">
            <el-input v-model.trim="item.Mn" placeholder="请输入MN号"></el-input>
          </el-form-item>
          <el-form-item label="内存" prop="Mn">
            <el-input v-model.trim="item.Mn" placeholder="请输入MN号"></el-input>
          </el-form-item>
          <el-form-item label="操作系统版本" prop="Mn">
            <el-input v-model.trim="item.Mn" placeholder="请输入MN号"></el-input>
          </el-form-item>
          <el-form-item label="操作系统安装日期" prop="ProductionDay">
            <el-date-picker
              v-model="item.ProductionDay"
              style="width:100%"
              type="date"
              placeholder="选择出厂日期"
            ></el-date-picker>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting || !item.Name || !item.Sn">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
    deviceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        Name: [
          { required: true, message: '数采仪名称不能为空', trigger: 'blur' },
          { max: 100, message: '数采仪名称不能超过100个字', trigger: 'blur' },
        ],
        Sn: [
          { required: true, message: '数采仪编号不能为空', trigger: 'blur' },
        ],
      },
      submitting: false,
      dsTabVisible: '0',
      softwareList: [],
    };
  },
  created() {
    this.getSoftWare();
  },
  methods: {
    getSoftWare() {
      this.$axios.get('softwareversion').then((response) => {
        this.softwareList = response.data.data;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    onOpen() {
      this.item = _.clone(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = { ...this.item };
        if (itemData.SoftwareVersionID === '') {
          itemData.SoftwareVersionID = 0;
        }
        // 保存的操作
        this.$axios.request({
          url: this.item.ID ? `dcidevice/${itemData.ID}` : 'dcidevice',
          method: itemData.ID ? 'put' : 'post',
          data: itemData,
        }).then(() => {
          this.$message.success(itemData.ID ? '编辑成功' : '新增成功');
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', true);
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', false);
          this.$emit('form:saved', false);
        });
      });
    },
  },
};
</script>
